export default function(state=[], action) {

    switch(action.type) {
        
        case "DOMAINS":
            return action.payload;

        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/reducers/ReducerDomains.js